'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  return typeof window !== 'undefined' && typeof window.navigator !== 'undefined' && window.navigator.product === 'ReactNative';
};


//////////////////
// WEBPACK FOOTER
// ./~/redux-first-router/dist/pure-utils/isReactNative.js
// module id = 1087
// module chunks = 2